

var statALL={
    one:[
        "最佳质量奖为项目角度的评选奖项，侧重项目完成质量、代码的可读性、文档的完整度使得项目具有可延续性。",
    
        "突出贡献奖为社区角度的评选奖项，侧重学生对社区的贡献度、完成项目对社区的重要性等。",
        
       "最快进步奖为学生角度的评选奖项，侧重学生参与活动的进步程度和快速学习能力。",
        
        "最具潜力奖为开源角度的评选奖项，侧重学生展现出未来持续贡献开源的潜力和意愿。"
    ],
    two:[
        "1. 由各社区推选结项的至多 2 位符合条件的学生名单交由组委会，组委会共计收到 35 名社区推荐学生。",

        "2. 指导委员会的老师根据奖项分为4个评审小组，每位老师 3 票（分为 5 分、3 分、1 分），投给选择的 3 名同学。获得分数最多的 5 位同学获得对应的奖项，若有同分，则第一选票多者中选；若有同分且第一选票数量相同，则第二选票多者中选。"
        
    ],
    three:"*评选依据包括项目申请书、代码仓库、结项报告、结项评审意见、社区推荐理由等多个方面。"
}

export default statALL